<template>
  <div class="container">
    <div class="video-wrapper">
      <div class="title-wrapper">
        <span style="width: 30%">视频中心</span>
        <span class="more" @click="toList(columnId)">更多</span>
      </div>
        <div class="scroll-wrapper" @click="handleClick($event)">
          <vue-seamless-scroll
            :data="videoList"
            :class-option="classOption"
            v-if="videoList.length > 0"
          >
            <div style="display: flex;">
              <div class="scroller-item" v-for="(item, index) in videoList" :key="index">
                <div class="img-wrapper">
                  <img :src="item.img" class="scroller-img"  :data-obj="JSON.stringify(item)" id="imgSrc"/>
                  <span class="iconfont play"  :data-obj="JSON.stringify(item)">&#xe662;</span>
                </div>
                <p class="video-title" :title="item.title">{{item.title}}</p>
              </div>
            </div>
          </vue-seamless-scroll>
        </div>
    </div>

    <div class="cover-container" v-if="showVideo">
      <span class="close"><a @click="showVideo = false">关闭</a></span>
      <div class="video">
      <video-player
                    class="video-player vjs-custom-skin"
                    ref="videoPlayer"
                    :options="playerOptions"
      ></video-player>
      </div>
    </div>
  </div>
</template>

<script>
import 'video.js/dist/video-js.css'
import { videoPlayer } from 'vue-video-player'

export default {
  name: 'Shanghai',
  components: {
    videoPlayer
  },
  props: {
    shanghai: {
      required: true
    }
  },
  watch: {
    shanghai: function (data) {
      if (!data) {
        return
      }
      this.columnId = data[0].id
      const list = data[0].content
      list.forEach(item => {
        const video = {
          title: item.title,
          img: item.thumbnail,
          url: item.video_url
        }
        this.videoList.push(video)
      })
    }
  },
  data () {
    return {
      imgSrc: '',
      videoList: [],
      columnId: '',
      playerOptions: {
        // videojs options
        autoplay: true,
        muted: false,
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [{
          type: 'video/mp4',
          src: ''
        }],
        poster: '/static/images/author.jpg'
      },
      themeList: [],
      classOption: {
        direction: 2,
        limitMoveNum: 3
      },
      videoImgList: [],
      showVideo: false
    }
  },
  methods: {
    toList (id) {
      this.$router.push(`/news/${id}`)
    },
    handleClick (evnet) {
      const item = JSON.parse(evnet.target.dataset.obj)
      this.showVideo = true
      this.playerOptions.sources[0].src = item.url
    }
  }
}
</script>

<style scoped>
  html {
    overflow-y: hidden;
  }

  .container {
    width: 1180px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .video-wrapper {
    height: 350px;
    width: 100%;
    box-sizing: border-box;
    box-shadow: 1px 1px 4px #ccc;
    padding: 0 20px;
    border: 1px solid #ccc;
  }

  .scroll-wrapper {
    width: 1138px;
    height: 220px;
    margin-top: 20px;
    overflow: hidden;
  }

  .scroller-item {
    width: 360px;
    height: 220px;
    margin-right: 20px;
  }

  .scroller-img {
    width: 360px;
    height: 200px;
  }

  .img-wrapper {
    position: relative;
  }

  .play {
    position: absolute;
    top: 40%;
    left: 50%;
    color: #ffffff;
    font-size: 40px;
    transform: translateY(-50%);
    transform: translateX(-50%);
    display: none;
  }

  .img-wrapper:hover {
    background-color: #333333;
    cursor: pointer;
  }

  .img-wrapper:hover img {
    opacity:0.6;
    filter: alpha(opacity=60);
  }

  .img-wrapper:hover .play {
    display: block;
  }

  .video-title {
    line-height: 20px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
  }

  .theme-wrapper {
    width: 390px;
    height: 350px;
    border: 1px solid #ccc;
    box-sizing: border-box;
    padding: 0 20px;
    display: flex;
    flex-direction: column;
    box-shadow: 1px 1px 4px #ccc;
  }

  .title-wrapper {
    height: 60px;
    border-bottom: 1px solid #ccc;
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 700;
    color: rgb(1, 142, 214);
  }

  .theme-list {
    flex: 1;
    padding: 10px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
  }

  .theme-img {
    width: 348px;
    height: 80px;
  }

  .cover-container {
    background: rgba(0,0,0,0.5);
    top:0;
    right:0;
    left:0;
    bottom:0;
    position:fixed;
    z-index: 999;
  }

  .close {
    color: #fff;
    position: fixed;
    top: 8%;
    right: 10%;
    cursor: pointer;
  }

  .close:hover {
    text-decoration: underline;
  }

  .video {
    width: 900px;
    margin: 0 auto;
  }

  .video >>>.video-js {
    width: 914px;
    height: 500px;
    border: none;
    position: absolute;
    margin: 0 auto;
    top: 50%;
    transform: translateY(-50%);
  }

  .video >>> .vjs-big-play-button {
    width: 78px;
    height: 78px;
    line-height: 76px;
    border-radius: 50px;
    font-size: 50px;
    border: none;
    top: 50%;
    left: 45%;
    transform: translateX(-50%);
    transform: translateY(-50%);
  }

  .more {
    width: 100%;
    text-align: right;
    font-size: 12px;
    color: #ccc;
  }

  .more:hover {
    text-decoration: underline;
    cursor: pointer;
  }
</style>
